import React from "react";

function LanguageSwitcher({ language, setLanguage, rightOffset = 20 }) {
    return (
        <div className="fixed top-4 z-50" style={{ right: rightOffset }}>
            <div className="flex gap-1">
                <button
                    className={`px-4 py-2 text-xs font-medium border-none cursor-pointer transition-all duration-300 min-w-[60px] text-center rounded-3xl backdrop-blur-md border ${
                        language === "en"
                            ? "bg-orange-500 text-white font-bold shadow-lg border-orange-500"
                            : "bg-white/50 text-gray-500/80 border-white/20 hover:bg-white/70 hover:text-gray-500 hover:-translate-y-px"
                    } shadow-md`}
                    onClick={() => setLanguage("en")}
                >
                    English
                </button>
                <button
                    className={`px-4 py-2 text-xs font-medium border-none cursor-pointer transition-all duration-300 min-w-[60px] text-center rounded-3xl backdrop-blur-md border ${
                        language === "zh"
                            ? "bg-orange-500 text-white font-bold shadow-lg border-orange-500"
                            : "bg-white/50 text-gray-500/80 border-white/20 hover:bg-white/70 hover:text-gray-500 hover:-translate-y-px"
                    } shadow-md`}
                    onClick={() => setLanguage("zh")}
                >
                    繁體中文
                </button>
            </div>
        </div>
    );
}

export default LanguageSwitcher;
